import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SectionTitle from '../layout/SectionTitle';
import { Link } from 'react-router-dom';

const Batiment = () => {
  const { t } = useTranslation();

  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-10 xl:gap-16 items-center">
          {/* Left Column - Image + Triangle élargi */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative order-1"
          >
            <div className="relative z-10 rounded-lg shadow-2xl">
              <div className="rounded-lg overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-socabeg-dark-gray/30 z-10" />
                <img
                  src="/images/batiment.jpg"
                  alt={t('construction.building.imageAlt')}
                  className="w-full object-cover relative z-0 h-[420px] md:h-[560px] lg:h-[600px]"
                  loading="lazy"
                />
              </div>
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6 order-2"
          >
            {/* Section Title */}
            <div className="mb-2">
              <SectionTitle
                overline={t('construction.building.title')}
                highlight=""
                align="left"
                showLogo={true}
              />
            </div>

            {/* Description */}
            <div className="space-y-4 text-gray-600 leading-relaxed text-justify">
              <p className="font-bold text-xl">{t('construction.building.subtitle')}</p>
              <p>{t('construction.building.paragraph1')}</p>
              <p>{t('construction.building.paragraph2')}</p>
              <p>{t('construction.building.paragraph3')}</p>
              <p>{t('construction.building.paragraph4')}</p>
            </div>

            {/* CTA Button */}
            <Link
              to="/contact"
              className="inline-block mt-6 bg-socabeg-red hover:bg-socabeg-red/90 text-white font-medium py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105"
            >
              {t('construction.building.cta')}
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Batiment;
